const { EVENTS } = window.BAO

class PreOrderRequestForm extends window.BAO.CustomElement() {
  static get requiredElements () {
    return [
      'form',
      'submit',
      'view',
      'preferred-contact-method-input',
      'phone-input',
      'email-input',
    ]
  }

  static get requiredExternalElements () {
    return ['quantity']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.externalQuantityAdjuster) {
      this.quantity = this.externalQuantityAdjuster.value
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.form.element,
      'submit',
      this.handleSubmit.bind(this),
    )

    this.els['preferred-contact-method-input'].elements.forEach(input => {
      this.listeners.add(
        input,
        'input',
        this.handlePreferredContactMethodChange.bind(this),
      )
    })

    if (this.externalQuantityAdjuster) {
      this.listeners.add(
        this.externalQuantityAdjuster,
        EVENTS.QUANTITY_ADJUSTER.CHANGE,
        this.handleQuantityChange.bind(this),
      )
    }

    if (this.externalEls.modal) {
      this.externalEls.modal.element.setupCloseListeners()
    }
  }

  /** @param {Event} event */
  handlePreferredContactMethodChange (event) {
    const emailIsRequired = event.target.value.toLowerCase() === 'email'
    const phoneIsRequired = !emailIsRequired

    this.els['email-input'].element.required = emailIsRequired
    this.els['phone-input'].element.required = phoneIsRequired
  }

  /** @param {SubmitEvent} event */
  handleSubmit (event) {
    event.preventDefault()

    this.submitRequest()
  }

  /**
   * @param {CustomEvent<{
   *  oldValue: number;
   *  value: number;
   * }>} event
   */
  handleQuantityChange (event) {
    this.quantity = event.detail.value
  }

  async submitRequest () {
    /** @type {HTMLFormElement} */
    const form = this.els.form.element
    const body = new FormData(form)

    try {
      await fetch(form.action, {
        method: form.method,
        body,
      })

      this.activeView = 'success'
    } catch (error) {}
  }

  /** @returns {number} */
  get quantity () {
    return this.els.quantity.element.value
  }

  set quantity (quantity) {
    this.els.quantity.element.value = quantity
  }

  /** @returns {'form' | 'success'} */
  get activeView () {
    return this.els.view.elements.find(view => {
      return view.getAttribute('aria-hidden') === 'false'
    }).dataset.key
  }

  set activeView (key) {
    const viewWithKeyExists = this.els.view.elements.some(
      view => view.dataset.key === key,
    )

    if (!viewWithKeyExists) {
      throw new Error(`Cannot find "${key}" view`)
    }

    this.els.view.elements.forEach(view => {
      view.setAttribute('aria-hidden', view.dataset.key !== key)
    })
  }

  /** @returns {string} */
  get productHandle () {
    return this.dataset.productHandle
  }

  /** @returns {HTMLElement | undefined} */
  get externalQuantityAdjuster () {
    return this.externalEls.quantity.elements.find(
      quantityAdjuster =>
        quantityAdjuster.dataset.productHandle === this.productHandle,
    )
  }
}

if (!window.customElements.get('pre-order-request-form')) {
  window.customElements.define('pre-order-request-form', PreOrderRequestForm)
}
